import { render, staticRenderFns } from "./Top-Home-Dynamic-Group.vue?vue&type=template&id=fac00e44"
import script from "./Top-Home-Dynamic-Group.vue?vue&type=script&lang=js"
export * from "./Top-Home-Dynamic-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports